import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Box, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@mui/material/styles';

RadioCard.propTypes = {
  value: PropTypes.string.isRequired,
  selectedValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node,
  children: PropTypes.node,
  disabled: PropTypes.bool
};

export default function RadioCard({
  value,
  selectedValue,
  onChange,
  title,
  description,
  icon,
  children,
  disabled = false
}) {
  const selected = selectedValue === value;
  const theme = useTheme();

  const handleClick = () => {
    if (!disabled) {
      onChange(value);
    }
  };

  return (
    <Card
      sx={{
        border: '2px solid',
        borderColor: selected ? 'primary.main' : theme.palette.action.disabledBackground,
        color: selected ? 'primary.main' : 'grey.500',
        bgcolor: selected
          ? alpha(theme.palette.primary.main, 0.06)
          : theme.palette.action.disabledBackground,
        opacity: disabled ? 0.6 : 1,
        transition: 'all 0.2s',
        position: 'relative',
        width: '100%'
      }}
    >
      <CardActionArea
        onClick={handleClick}
        disabled={disabled}
        component="div"
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start'
        }}
      >
        <CardContent sx={{}}>
          <Stack direction="column" spacing={1} justifyContent="flex-start">
            <Stack direction="row" spacing={1}>
              {icon && <Box sx={{ display: 'flex', alignItems: 'center' }}>{icon}</Box>}
              <Typography variant="h6">{title}</Typography>
            </Stack>
            {/* Text */}
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {description}
              </Typography>
            </Box>
            {/* EXTRA CONTENT AREA */}
            {children && <Box>{children}</Box>}
          </Stack>

          {/* Checkmark */}
          {selected && (
            <CheckCircleIcon color="primary" sx={{ position: 'absolute', top: 12, right: 12 }} />
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
